import { Empty, Flex, Form, Typography } from 'antd'
import { useIntl } from 'react-intl'
import Button from '../../../../common/Button'
import InputText from '../../../../common/InputText'
import TextArea from '../../../../common/TextArea'
import NoRecordsFound from '../../../../common/NoRecordsFound'
import SalesCodeListPanel from './SalesCodeListPanel'
import RecordsCount from '../../../../common/RecordsCount'

const SelectSalesCodesBody = ({
  filterData,
  selectedSalesCodes,
  onToggleCode,
  onSearch,
  importJson,
  setImportJson,
  salesCodeListName,
  setSalesCodeListName,
  onSaveGrid,
  onSaveJson,
  salesCodeList,
  expandedRowKeys,
  expandedDetails,
  onToggleExpand,
  onPreview,
  onDelete,
}) => {
  const intl = useIntl()
  return (
    <Flex gap={16} align="flex-start" className="sales-code-preview-body">
      <Flex
        vertical
        gap={importJson.show ? 8 : 4}
        className='sales-code-left-col-wrapper'
      >
        <Flex justify="space-between" align="center">
          <Typography.Text className="bold">
            {importJson.show ? intl.formatMessage({ id: 'functionalDiagram.addSalesCodeJson' }) : intl.formatMessage({ id: 'functionalDiagram.selectSalesCode' })}
          </Typography.Text>
          {importJson.show && (
            <Button onClick={() => setImportJson({ show: false, data: '' })}>
              {intl.formatMessage({ id: 'functionalDiagram.selectSalesCodesAction' })}
            </Button>
          )}
        </Flex>

        {importJson.show ? (
          <Form style={{ marginBottom: 8 }}>
            <TextArea
              name="sales_code_json"
              label={intl.formatMessage({ id: 'functionalDiagram.salesCodeJson' })}
              hideLabel={true}
              value={importJson.data}
              style={{ height: '48vh' }}
              onChange={(value) =>
                setImportJson({ ...importJson, data: value })
              }
              isRequired={false}
              placeholder={intl.formatMessage({ id: 'functionalDiagram.pasteSalesCodeJson' })}
              rows={12}
            />
          </Form>
        ) : (
          <Flex
            vertical
            gap={16}
            className="select-sales-code-container"
          >
            <Form>
              <Flex gap={16}>
                <InputText
                  type="search"
                  name="search_sales_code"
                  placeholder={intl.formatMessage({ id: 'functionalDiagram.searchSalesCodePlaceholder' })}
                  isRequired={false}
                  wrapperClass="search-sales-code"
                  onChange={onSearch}
                />

                <Button
                  onClick={() =>
                    setImportJson({ show: !importJson.show, data: '' })
                  }
                  testId="fd-json-toggle"
                >
                  {importJson.show ? intl.formatMessage({ id: 'functionalDiagram.selectSalesCodesAction' }) : intl.formatMessage({ id: 'functionalDiagram.uploadJson' })}
                </Button>
              </Flex>
            </Form>

            <Flex
              wrap="wrap"
              justify="space-between"
              gap={8}
              className="sales-code-grid"
            >
              {filterData?.map((code) => (
                <Button
                  key={code.value}
                  type={
                    selectedSalesCodes.includes(code.value)
                      ? 'primary'
                      : 'default'
                  }
                  onClick={() => onToggleCode(code.value)}
                  testId="fd-sales-code-option"
                >
                  {code.label}
                </Button>
              ))}
              {filterData?.length === 0 && (
                <Empty
                  description={<RecordsCount count={0} />}
                  style={{
                    margin: '0 auto',
                    height: 'calc(100vh - 536px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                />
              )}
            </Flex>
          </Flex>
        )}

        <Flex vertical gap={8}>
          <Typography.Text>{intl.formatMessage({ id: 'functionalDiagram.enterSalesCodeListName' })}</Typography.Text>
          <Flex gap={8}>
            <Form style={{ flex: 1 }}>
              <InputText
                name="sales_code_list_name"
                placeholder={intl.formatMessage({ id: 'functionalDiagram.enterSalesCodeListName' })}
                isRequired={false}
                value={salesCodeListName}
                onChange={setSalesCodeListName}
              />
            </Form>
            <Button
              type="primary"
              onClick={importJson.show ? onSaveJson : onSaveGrid}
              testId="fd-sales-list-save"
            >
              {intl.formatMessage({ id: 'functionalDiagram.saveSalesCodeList' })}
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <Flex vertical gap={4} style={{ flex: 1, minWidth: 0 }}>
        <Typography.Text className="bold">
          {intl.formatMessage({ id: 'functionalDiagram.selectedReferencesDuplication' })}
        </Typography.Text>
        <SalesCodeListPanel
          salesCodeList={salesCodeList}
          expandedRowKeys={expandedRowKeys}
          expandedDetails={expandedDetails}
          onToggleExpand={onToggleExpand}
          onPreview={onPreview}
          onDelete={onDelete}
        />
      </Flex>
    </Flex>
  )
}

export default SelectSalesCodesBody
